import { Reveal } from "./Reveal";

export const SectionHeading = ({ eyebrow, title, text, dark = false, align = "left" }) => (
  <Reveal className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && (
      <p className={`flex items-center gap-3 text-xs font-semibold tracking-[0.28em] uppercase mb-4 ${align === "center" ? "justify-center" : ""} ${dark ? "text-copper" : "text-copper"}`}>
        <span className="h-px w-8 bg-copper inline-block" aria-hidden="true" />
        {eyebrow}
      </p>
    )}
    <h2 className={`font-display font-extrabold leading-[1.08] text-[clamp(2rem,4vw,3.25rem)] ${dark ? "text-white" : "text-ink"}`}>
      {title}
    </h2>
    {text && (
      <p className={`mt-4 text-base sm:text-lg leading-relaxed ${dark ? "text-white/60" : "text-mute"}`}>
        {text}
      </p>
    )}
  </Reveal>
);
